import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialFloatOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"

export interface SeparateXyzSockets extends MaterialNodeSockets {
    inputs: {
        vector: "vector" // found in inputs: vector; found in settings: vector; inferred from data: float3
    }
    settings: {
        vector: "vector" // found in inputs: vector; found in settings: vector; inferred from data: float3
        x: "float" // found in inputs: -; found in settings: float; inferred from data: float
        y: "float" // found in inputs: -; found in settings: float; inferred from data: float
        z: "float" // found in inputs: -; found in settings: float; inferred from data: float
    }
    outputs: {
        x: "float"
        y: "float"
        z: "float"
    }
}

export const separateXyzDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeSeparateXYZ,
    },
    nodeClass: "SeparateXyz",
    ui: {
        label: "Separate XYZ",
        color: "#4987af",
        items: [
            {name: "x", valueType: "float", label: "X", output: true},
            {name: "y", valueType: "float", label: "Y", output: true},
            {name: "z", valueType: "float", label: "Z", output: true},
            {name: "vector", valueType: "vector", label: "Vector", input: true, setting: true, defaultValue: {x: 0, y: 0, z: 0}},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({x: materialFloatOutput, y: materialFloatOutput, z: materialFloatOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({vector: optionalMaterialInput}),
            settings: z.strictObject({
                vector: z.optional(z.strictObject({x: z.number(), y: z.number(), z: z.number()})),
                x: z.optional(z.number()),
                y: z.optional(z.number()),
                z: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<SeparateXyzSockets>
